import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index';

Vue.use(VueRouter)

const routes = [
{
    path: '/',
    name: 'Home',
    component: {
        beforeRouteEnter(to, from, next) {
            next({ path:  '/profile' });          
        }
    }, 
    meta: { header: false, requiresAuth: true , title: 'داشبورد کاربری' },
}, {
    path: '/dashboards',
    name: 'Dashboards',
    component: () =>
        import ('../views/Dashboard/DashboardList.vue'),
    meta: { header: false, editable: false, requiresAuth: true , title: 'داشبورد‌ها' },

}, {
    path: '/dashboard/:id',
    name: 'Dashboard',
    component: () =>
        import ('../views/Dashboard/Dashboard.vue'),
    meta: { header: false, editable: false, requiresAuth: true , title: 'داشبورد' },
}, {
    path: '/dashboard/edit/:id',
    name: 'DashboardEdit',
    component: () =>
        import ('../views/Dashboard/DashboardEdit.vue'),
    meta: { header: false, editable: true, requiresAuth: true , title: 'ویرایش داشبورد' },
}, {
    path: '/alert',
    name: 'AlertsView',
    component: () =>
        import ('../views/Alerts.vue'),
    meta: { requiresAuth: true , title: 'هشدار‌ها' },
},{
    path: '/widgets',
    name: 'WidgetsView',
    component: () =>
        import ('../views/Widgets.vue'),
    meta: { requiresAuth: true , title: 'ابزارک‌ها' },
},{
    path: '/favorites',
    name: 'FavoritesView',
    component: () =>
        import ('../views/Favorites.vue'),
    meta: { requiresAuth: true , title: 'نشان‌شده‌ها' },
},{
    path: '/todo',
    name: 'TodoView',
    component: () =>
        import ('../views/Todo.vue'),
    meta: { requiresAuth: true , title: 'وظایف روزانه' },
},{
    path: '/notes',
    name: 'NotesView',
    component: () =>
        import ('../views/Notes.vue'),
    meta: { requiresAuth: true , title: 'یادداشت‌ها و اسناد' },
},{
    path: '/watch-list',
    name: 'WatchListsView',
    component: () =>
        import ('../views/WatchLists.vue'),
    meta: { requiresAuth: true , title: 'فهرست‌ها' },
},{
    path: '/calendar-table',
    name: 'CalendarTable',
    component: () =>
        import ('../views/CalendarTable.vue'),
    meta: { requiresAuth: true , title: 'جدول تقویم'}
}, {
    path: '/calendar-view',
    name: 'CalendarView',
    component: () =>
        import ('../views/CalendarView.vue'),
    meta: { requiresAuth: true , title: 'تقویم اقتصادی'}
},{
    path: '/technical',
    name: 'NewTechnical',
    component: () =>
        import ('../views/Technicals.vue'),
    meta: { requiresAuth: true , title: 'تحلیل‌ها' },
}, {
    path: '/technicals',
    name: 'PublicTechnical',
    component: () =>
        import ('../views/PublicTechnical.vue'),
    meta: { requiresAuth: false , title: 'تحلیل‌های تکنیکال' },
}, {
    path: '/technical/view',
    name: 'ViewTechnical',
    component: () =>
        import ('../views/ViewTechnical.vue'),
    meta: { requiresAuth: false , title: 'مشاهده تحلیل تکنیکال'}
}, {
    path: '/investment',
    name: 'Investment',
    component: () =>
        import ('../views/Investment/General.vue'),
    meta: { requiresAuth: true , title: 'سرمایه گذاری'}
}, {
    path: '/investment/inventory',
    name: 'InvestmentInventory',
    component: () =>
        import ('../views/Investment/Inventory.vue'),
    meta: { requiresAuth: true , title: 'دارایی‌ها'}
}, {
    path: '/investment/sell-history',
    name: 'InvestmentSellHistory',
    component: () =>
        import ('../views/Investment/SellHistory.vue'),
    meta: { requiresAuth: true , title: 'تاریخچه فروش'}
}, {
    path: '/investment/buy-history',
    name: 'InvestmentBuyHistory',
    component: () =>
        import ('../views/Investment/BuyHistory.vue'),
    meta: { requiresAuth: true , title: 'تاریخچه خرید'}
}, {
    path: '/investment/watch',
    name: 'InvestmentWatch',
    component: () =>
        import ('../views/Investment/Watch.vue'),
    meta: { requiresAuth: true , title: 'نرخ‌های سرمایه‌گذاری'}
}, {
    path: '/profile',
    name: 'Profile',
    component: () =>
        import ('../views/Profile/View.vue'),
    meta: { header: true, requiresAuth: true , title: 'پروفایل'},

}, {
    path: '/profile/edit',
    name: 'ProfileEdit',
    component: () =>
        import ('../views/Profile/Edit.vue'),
    meta: { header: true, requiresAuth: true , title: 'ویرایش پروفایل'},
}, {
    path: '/profile/technical',
    name: 'ProfileTechnical',
    component: () =>
        import ('../views/Profile/Technical.vue'),
    meta: { header: true, requiresAuth: true , title: 'تحلیل‌های من'},
}, {
    path: '/profile/following',
    name: 'ProfileFollowing',
    component: () =>
        import ('../views/Profile/Following.vue'),
    meta: { header: true, requiresAuth: true , title: 'دنبال‌شوندگان من'},

}, {
    path: '/profile/followers',
    name: 'ProfileFollowers',
    component: () =>
        import ('../views/Profile/Followers.vue'),
    meta: { header: true, requiresAuth: true , title: 'دنبال‌کنندگان من'},

}, {
    path: '/profile/_/:username',
    name: 'ProfileOthers',
    component: () =>
        import ('../views/ProfileOthers/View.vue'),
    meta: { header: true, requiresAuth: false , title: 'پروفایل کاربر'},
}, {
    path: '/profile/_/:username/technical',
    name: 'ProfileTechnicalOthers',
    component: () =>
        import ('../views/ProfileOthers/Technical.vue'),
    meta: { header: true, requiresAuth: false , title: 'تحلیل‌های کاربر'},
}, {
    path: '/profile/_/:username/following',
    name: 'ProfileFollowingOthers',
    component: () =>
        import ('../views/ProfileOthers/Following.vue'),
    meta: { header: true, requiresAuth: false , title: 'دنبال‌شوندگان کاربر'},

}, {
    path: '/profile/_/:username/followers',
    name: 'ProfileFollowersOthers',
    component: () =>
        import ('../views/ProfileOthers/Followers.vue'),
    meta: { header: true, requiresAuth: false , title: 'دنبال‌کنندگان کاربر'},

}, {
    path: '/comment',
    name: 'Comment',
    component: () =>
        import ('../views/TgjuPosts.vue'),
    meta: { header: false, editable: false, requiresAuth: false , title: 'نظرات'},
}, {
    path: '/forums',
    name: 'Forums',
    component: () =>
        import ('../views/Forums.vue'),
    meta: { header: false, requiresAuth: true , title: 'گروه‌ها'},
}, {
    path: '/market',
    name: 'MarketViews',
    component: () =>
        import ('../views/Market.vue'),
    meta: { header: false, requiresAuth: true }
}, {
    path: '/market/page/:name',
    name: 'MarketStatic',
    component: () =>
        import ('../views/Market/Static.vue'),
    meta: { header: false, requiresAuth: true }
}, {
    path: '/market/profile/:name/summery',
    name: 'MarketProfile',
    component: () =>
        import ('../views/Market/Profile/Summery.vue'),
    meta: { header: false, requiresAuth: true }
}, {
    path: '/market/profile/:name/charts',
    name: 'MarketCharts',
    component: () =>
        import ('../views/Market/Profile/Chart.vue'),
    meta: { header: false, requiresAuth: true }
}, {
    path: '/market/profile/:name/archive',
    name: 'MarketArchive',
    component: () =>
        import ('../views/Market/Profile/Archive.vue'),
    meta: { header: false, requiresAuth: true }
}, {
    path: '/market/dynamic/:market_id',
    name: 'MarketList',
    component: () =>
        import ('../views/Market/Dynamic.vue'),
    meta: { header: false, requiresAuth: true }
}, {
    path: '/auth/login',
    name: 'Login',
    component: () =>
        import ('../views/LoginRegisterView.vue'),
    meta: { title: 'ورود - ثبت‌نام'},
}, {
    path: '/auth/sso',
    name: 'AuthSso',
    component: {
        beforeRouteEnter(to, from, next) {
            store.commit('setAccessToken', to.query.token);
            store.dispatch('setUserData')
                .then(response => {
                    // سینک کردن منو های داشبورد از دیتابیس
                    store.dispatch('setDashboards', { forced: true });
                    // ثبت کد پوش نوتیفیکیشن برای کاربر
                    store.dispatch('setFirebaseToken', { forced: true });
                    //---------------
                    next({ path: '/profile', });
                });
        }
    }
}, {
    path: '/auth/logout',
    name: 'Logout',
    component: {
        beforeRouteEnter(to, from, next) {
            Vue.prototype.$helpers.logout();
            location.replace(process.env.VUE_APP_URL + `/auth/login?redirect=${to.fullPath != '/auth/logout' ? to.fullPath : ''}`);
        }
    }
}, {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () =>
        import ('../views/partials/NotFound.vue'),
    meta: { header: false, editable: false, requiresAuth: false , title: 'صفحه‌ی مورد نظر یافت نشد'},
}

]


const router = new VueRouter({
    mode: 'history',
    base: (process.env.VUE_APP_ENV == 'production' && process.env.VUE_APP_SUB_FOLDER_DEPLOY_STATUS == "true") ? ('/' + process.env.VUE_APP_SUB_FOLDER_DEPLOY_DIR + '/') : process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    // تغییر عنوان صفحه
    document.title = to.meta.title ? to.meta.title : 'داشبورد کاربری';
        
    let userAuth = Vue.prototype.$helpers.userAuth();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!userAuth) {
            next({
                path: '/auth/login',
                query: {
                    redirect: to.fullPath,
                },
            });
        } else {
            next();
        }
    } else {
        next();
    }

});

router.afterEach((to, from) => {
    document.body.setAttribute('data-route', to.name);
    store.commit('routeChanged', to);
});

export default router